<template>
  <div
    class="marker"
    :style="{
      width: width + 'px',
      height: anchor + 'px',
      margin: `-${anchor}px 0 0 -${width/2}px`,
      fill,
      color,
      stroke: strokeColor
    }"
  >
    <svg viewBox="0 0 155 200">
      <use xlink:href="#markerIcon" />
    </svg>
    <div
      :style="{
        width: width + 'px',
        height: width + 'px'
      }"
    >
      <q-img
        v-if="type === 'img'"
        :src="icon"
        :style="{
          width: iconSize + 'px',
          height: iconSize + 'px'
        }"
      />
      <q-icon
        v-else
        :name="icon"
        :size="iconSize + 'px'"
      />
    </div>

  </div>
</template>

<script>
import { QIcon, QImg } from 'quasar'

export default {
  props: ['type', 'icon', 'fill', 'color', 'width', 'height', 'anchor', 'strokeColor'],
  components: {
    QIcon,
    QImg
  },
  computed: {
    computedFill () {
      return this.fill
    },
    computedColor () {
      return this.color
    },
    computedStroke () {
      return this.strokeColor
    },
    iconSize () {
      return this.width * 0.5
    }
  }
}
</script>

<style>
  .marker {
    overflow-y: visible;
    position: relative;
    top: 0;
    left: 0;
    pointer-events: none; /* Only the symbol should have the events. See IconsGenerator.vue */
  }
  .marker > * {
    position: absolute;
  }
  .marker > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  .marker > svg {
    z-index: unset;
    width: 100%;
    height: auto;
    stroke-width: 8;
  }

  .marker-status {
    border-radius: 50%;
  }
</style>
